import { OptionType } from "components/Inputs/Select";
import React from "react";
import { Control, ControllerRenderProps, Path } from "react-hook-form";

export enum AnswerType {
  CHECKBOX = "checkbox",
  SELECT = "select",
  TEXT = "text",
  TEXTAREA = "textarea",
}

export type QuestionType<T> = {
  name: Path<T>;
};

export type QuestionProps<T> = {
  children?: React.ReactNode;
  control: Control<T>;
  disabled?: boolean;
  isSubmitting?: boolean;
  label: string;
  question: QuestionType<T>;
  options?: OptionType[];
  rows?: number;
  type?: AnswerType;
};

export type AnswerProps<T> = {
  children?: React.ReactNode;
  disabled?: boolean;
  field: ControllerRenderProps<T, Path<T>>;
  invalid: boolean;
  isSubmitting?: boolean;
  label: string;
  options?: OptionType[];
  rows?: number;
  type: AnswerType;
};
